import { useQuery } from '@tanstack/react-query'
import { keys } from '@/api/hooks/shared/keys'
import { loadBlockedIps } from './blockedIpData'
import type { BlockedIpQuery } from './blockedIpTypes'

/** Blocked IP — live Keycloak → Agent-API `getBlockedIps`. */
export function useBlockedIps(query: BlockedIpQuery) {
  return useQuery({
    queryKey: keys.blockedIps(query),
    queryFn: () => loadBlockedIps(query),
    placeholderData: (previous) => previous,
    retry: false,
  })
}
